var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssists(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.944 44.9937C101.193 44.9937 72.9775 73.206 72.9775 107.96C72.9775 142.711 101.193 170.926 135.944 170.926C170.695 170.926 198.91 142.711 198.91 107.96C198.91 73.206 170.695 44.9937 135.944 44.9937ZM135.944 72.9776C155.25 72.9776 170.926 88.6537 170.926 107.96C170.926 127.266 155.25 142.939 135.944 142.939C116.638 142.939 100.961 127.266 100.961 107.96C100.961 88.6537 116.638 72.9776 135.944 72.9776Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.816 191.915C339.065 191.915 310.85 220.128 310.85 254.882C310.85 289.632 339.065 317.848 373.816 317.848C408.57 317.848 436.782 289.632 436.782 254.882C436.782 220.128 408.57 191.915 373.816 191.915ZM373.816 219.899C393.122 219.899 408.798 235.575 408.798 254.882C408.798 274.188 393.122 289.861 373.816 289.861C354.51 289.861 338.837 274.188 338.837 254.882C338.837 235.575 354.51 219.899 373.816 219.899Z",
    fill: "#5A83FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.944 338.837C101.193 338.837 72.9775 367.049 72.9775 401.803C72.9775 436.554 101.193 464.77 135.944 464.77C170.695 464.77 198.91 436.554 198.91 401.803C198.91 367.049 170.695 338.837 135.944 338.837ZM135.944 366.821C155.25 366.821 170.926 382.497 170.926 401.803C170.926 421.11 155.25 436.782 135.944 436.782C116.638 436.782 100.961 421.11 100.961 401.803C100.961 382.497 116.638 366.821 135.944 366.821Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.072 166.897L273.043 222.082C278.54 227.506 287.406 227.442 292.83 221.941C298.253 216.444 298.189 207.578 292.689 202.155L236.721 146.969C231.22 141.546 222.354 141.609 216.931 147.11C211.511 152.607 211.571 161.473 217.072 166.897Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.972 288.954L217.001 344.922C211.541 350.383 211.541 359.252 217.001 364.712C222.462 370.172 231.331 370.172 236.791 364.712L292.759 308.741C298.219 303.28 298.219 294.415 292.759 288.954C287.298 283.494 278.433 283.494 272.972 288.954Z",
    fill: "#5A83FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.888 198.91V170.927H268.872C276.596 170.927 282.866 164.657 282.866 156.933C282.866 149.209 276.596 142.939 268.872 142.939H226.894C219.167 142.939 212.904 149.206 212.904 156.933V198.91C212.904 206.634 219.174 212.904 226.894 212.904C234.618 212.904 240.888 206.634 240.888 198.91Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.888 312.841H268.872V340.825C268.872 348.549 275.142 354.819 282.866 354.819C290.589 354.819 296.859 348.549 296.859 340.825V298.847C296.859 291.12 290.593 284.854 282.866 284.854H240.888C233.164 284.854 226.894 291.124 226.894 298.847C226.894 306.571 233.164 312.841 240.888 312.841Z",
    fill: "#5A83FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssists);
export default __webpack_public_path__ + "static/media/assists.f6964b817a8af0d245facb37abeeb0e2.svg";
export { ForwardRef as ReactComponent };